/*eslint-disable*/
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { forms } from 'seal-ui-components';
import mixpanelEvents from '@Mixpanel';
import { setSuggestedClauseFlags } from '@Actions/filterActions';
import { CheckBoxFilterDiv, InBodyTitle, StyledCheckBoxWrapper } from '../ScoreCardFilters.style';

const ClausesFilter = () => {
    const dispatch = useDispatch();

    const { suggestedClauseInput } = useSelector(state => state.scoreCardFilters);

    const handleClausesFlags = key => {
        suggestedClauseInput[key].selected = !suggestedClauseInput[key].selected;

        dispatch(setSuggestedClauseFlags(suggestedClauseInput));
        mixpanelEvents.scorecardFiltersApplied();
    };

    return (
        <CheckBoxFilterDiv>
            <InBodyTitle>Suggested clause:</InBodyTitle>
            <StyledCheckBoxWrapper>
                {Object.values(suggestedClauseInput).map((clause, idx) => (
                    <forms.CheckboxField
                        key={`clauses_${idx}`}
                        label={clause.text}
                        onChange={() => handleClausesFlags(clause.text)}
                        checked={clause.selected}
                    />
                ))}
            </StyledCheckBoxWrapper>
        </CheckBoxFilterDiv>
    );
};

export default ClausesFilter;
